import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Estagio from "model/producao/Estagio";
import Roteiro from "model/producao/Roteiro";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class RoteiroService implements BaseServiceCadastros<Roteiro> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/roteiro/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Roteiro>((resolve, reject): void => {
            api
                .get(`/roteiro/consultar/${id}`)
                .then(response => {
                    const roteiro: Roteiro = response.data;
                    roteiro.estagios.forEach(item => {
                        item.key = generateKey();
                        return item;
                    });
                    resolve(roteiro);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(roteiro: Roteiro) {
        return new Promise<Roteiro>((resolve, reject): void => {
            api
                .post(`/roteiro/incluir`, JSON.stringify(roteiro))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(roteiro: Roteiro) {
        return new Promise<Roteiro>((resolve, reject): void => {
            api
                .put(`/roteiro/editar`, JSON.stringify(roteiro))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/roteiro/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    estagios() {
        return new Promise<Estagio[]>((resolve, reject): void => {
            api
                .get(`/roteiro/estagios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    proximoCodigo(){
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/roteiro/proximoCodigo`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default RoteiroService;